module.exports = __webpack_public_path__ + "img/P34.4ff354b7.png";